import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import QueryManagementEmployee from 'graphql/queries/management/QueryManagementEmployee'
import QueryManagementEmployees from 'graphql/queries/management/QueryManagementEmployees'

export default class FetchManagementEmployee {

	static log( value ) {
		console.prefix('FetchManagementEmployee', value );
	}

	static fetch( employeeGuid, { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {}  ) {
		new GraphqlBuilder()
			.addQuery( 'employee', QueryManagementEmployee, {
				guid: employeeGuid,
				...variables
			})
			.setResultPath( ['employee', 'employee'], {}  )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( { employee: result } );
				}
			})
			.execute()
	}
	
	static fetchAll( { teamGuid = null, callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {}  ) {
		if( teamGuid !== null ) {
			variables[ 'team_guid' ] = teamGuid;
		}
		
		new GraphqlBuilder()
			.addQuery( 'employees', QueryManagementEmployees, variables )
			.setResultPath(['employees', 'employees' ], [] )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess( { employees: result } );
				}
			})
			.execute()
	}
}
